import { GridColumnProps } from "@progress/kendo-react-grid";

import i18n from "i18n";
import { PackagesNotReleased } from "interface/package";
import { GrideDateFormatter } from "ui/Date";
import CellPopover from "ui/grid/DescriptionCell";
import { NumericalCell, NumericalHeader } from "ui/grid/GridCommandCell";
import { CLASSNAME } from "utils/constant";
import { formatNorwegianNumber } from "utils/helper";
import { calculateFieldStats } from "utils/statUtils";

const t = i18n.t;

const numericColumn = (
	field: string,
	title: string,
	unit: string,
	width = "150px",
	data?: PackagesNotReleased[],
): GridColumnProps => ({
	field,
	title,
	width,
	headerClassName: CLASSNAME.TableNumeric,
	className: `${CLASSNAME.TableNumeric} `,
	cells: {
		data: (props) => <NumericalCell {...props} unit={unit} />,
		headerCell: (props) => <NumericalHeader {...props} />,
		...(data && {
			footerCell: (props) => (
				<td
					style={{ textAlign: "end", paddingRight: "2px" }}
					className={`${CLASSNAME.TableNumeric} no-border td-bold`}
				>
					{`${formatNorwegianNumber(
						calculateFieldStats(data, props.field as string).sum,
						2,
						2,
					)} ${unit}`}
				</td>
			),
		}),
	},
});

export const packagesNotReleasedGridColumnItem = (
	data: PackagesNotReleased[] = [],
): GridColumnProps[] => [
	{
		field: "registrationId",
		title: t("RegistrationIdShort"),
		width: "100px",
	},
	{
		field: "packageId",
		title: t("Package"),
		width: "90px",
	},
	{
		field: "salesDate",
		title: t("SalesDate"),
		width: "120px",
		cells: {
			data: (props) => (
				<GrideDateFormatter
					date={props.dataItem.salesDate}
					formatType="dd.MM.yyyy"
				/>
			),
		},
	},
	{
		field: "vesselRegistrationId",
		title: t("VesselRegistrationId"),
		width: "120px",
	},
	{
		field: "vesselName",
		title: t("VesselName"),
		cells: { data: (props) => <CellPopover {...props} /> },
	},
	{
		field: "buyerName",
		title: t("BuyerName"),
		cells: { data: (props) => <CellPopover {...props} /> },
	},
	{
		field: "registrationDate",
		title: t("RegistrationDateShort"),
		width: "120px",
		cells: {
			data: (props) => (
				<GrideDateFormatter
					date={props.dataItem.registrationDate}
					formatType="dd.MM.yyyy"
				/>
			),
			footerCell: (props) => (
				<td className={"no-border td-bold"}>{t("Total")}</td>
			),
		},
	},
	{ field: "salesType", title: t("Type"), width: "100px" },
	numericColumn("liveWeightKg", t("Weight"), "kg", "130px", data),
	numericColumn("grossAmount", t("BuyerGrossAmount"), "kr", "150px", data),
	numericColumn("vatAmount", t("Vat"), "kr", "130px", data),
	numericColumn("netAmount", t("BuyerNetAmount"), "kr", "150px", data),
];

export const packageLineDetailGridItems: GridColumnProps[] = [
	{
		field: "lineNumber",
		title: t("Line"),
		width: "30px",
	},
	{
		field: "lineNumber",
		title: t("Line"),
		width: "100px",
		cells: {
			data: (props) => (
				<td style={{ paddingLeft: "10px" }}>#{props.dataItem.lineNumber}</td>
			),
		},
	},
	{
		field: "description",
		title: t("Description"),
		cells: { data: (props) => <CellPopover {...props} /> },
	},
	numericColumn("liveWeightKg", t("Weight"), "kg"),
	numericColumn("price", t("Price"), "kr"),
	numericColumn("amount", t("Value"), "kr"),
	{
		width: "40px",
		className: `${CLASSNAME.TableNumeric} no-border`,
	},
];
